<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="600px"
  >
    <!--<editor-fold desc="Dialog Header">-->
    <template slot="dialogTitle">
      <span v-if="currencyExchangeMarginRateDirty.id">
        Edit currency exchange margin rate
      </span>
      <span v-else>
        Add new currency exchange margin rate
      </span>
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Form">-->
    <v-card-text :class="{'pa-5': !$vuetify.breakpoint.xsOnly }">
      <v-text-field
        v-model="currencyExchangeMarginRateDirty.years_in_future"
        type="number"
        min="1"
        step="1"
        label="Years in future"
        tip="Number of years in future that this margin rate represents"
        outlined
      />
      <v-text-field
        v-model="marginRateValue"
        type="number"
        min="0"
        step="0.01"
        suffix="%"
        label="Exchange margin rate"
        outlined
      />
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
import { cloneDeep } from 'lodash'

import ContentDialog from '@/components/helpers/Dialog'
import CurrencyExchangeMarginRate from '@/models/CurrencyExchangeMarginRate'
import Big from 'big.js'

export default {
  name: 'CurrencyExchangeMarginRateEditDialog',
  components: {
    ContentDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currencyExchangeMarginRate: {
      type: Object,
      default: () => CurrencyExchangeMarginRate.emptyModel
    }
  },
  data() {
    return {
      currencyExchangeMarginRateDirty: cloneDeep(this.currencyExchangeMarginRate),
      submitting: false
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    },
    marginRateValue: {
      get: function () {
        if (!this.currencyExchangeMarginRateDirty.rate) return ''

        return Big(this.currencyExchangeMarginRateDirty.rate).times(100).round(8).toString()
      },
      set: function (value) {
        this.currencyExchangeMarginRateDirty.rate = Big(value).div(100).round(8).toString()
      }
    }
  },
  watch: {
    currencyExchangeMarginRate() {
      this.currencyExchangeMarginRateDirty = cloneDeep(this.currencyExchangeMarginRate)
    }
  },
  methods: {
    async submit() {
      let validated = await this.$validator.validate()

      if (!validated) return

      this.save()
    },
    async save() {
      this.submitting = true

      let formData = {
        years_in_future: this.currencyExchangeMarginRateDirty.years_in_future,
        rate: this.currencyExchangeMarginRateDirty.rate
      }

      try {
        let currencyExchangeMarginRate = await CurrencyExchangeMarginRate.api.save(formData, this.currencyExchangeMarginRateDirty.id)

        this.$emit('update:currencyExchangeRate', currencyExchangeMarginRate)

        this.$store.dispatch('alert', {
          'text': 'Currency exchange margin rate Saved',
          'color': 'success'
        })

        this.modalVisible = false
      } catch (e) {
        if (e.response && e.response.status === 422) {
          this.$store.dispatch('alert', {
            'text': e.response.data.message,
            'color': 'warning'
          })
        } else {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
        }
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
